var $export = require('./_export');

$export($export.S + $export.F, 'Object', { isObject: require('./_is-object') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/core.object.is-object.js
// module id = ./node_modules/core-js/modules/core.object.is-object.js
// module chunks = 0